import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Pins the order-summary column below the sticky stepper band so the two
 * never overlap when the user scrolls. The `top` offset is owned by the
 * `.checkout-v2-sticky-summary` class in `style/checkoutV2.scss`, which
 * already shifts down to clear the WordPress admin bar when one is rendered
 * for logged-in editors.
 */ const StickyRightColumn = ({ children })=>/*#__PURE__*/ _jsx("div", {
        className: "checkout-v2-sticky-summary",
        children: children
    });
export { StickyRightColumn };
